import React, {useContext} from "react";
import {debug, notImplemented} from "../utils";
import {connect} from "react-redux";
import ValidationResultTableSearchSection from "../rules/ValidationResultTableSearchSection";
import {TableContext} from "../index";
import {acknowledgeViolations} from "./violationsService";
import {showSuccessToast, showWarningToast} from "../validation/ToastContainer";
import {useHistory} from "react-router-dom";
import {
    finishLocalProcessingTask,
    startLocalProcessingTask
} from "../processing-tasks/processingTasksRegistry";

function ViolationsTableHeader() {

    const {config} = useContext(TableContext);
    const selected = config.selected || [];
    const history = useHistory();

    const onAcknowledgeClick = () => {
        if (selected.length) {
            const processingTaskId = startLocalProcessingTask({
                id: `violations-acknowledge-${Date.now()}`,
                type: "Acknowledge",
                title: "Violations Acknowledge",
                details: `${selected.length} selected violation(s)`
            });

            acknowledgeViolations(selected)
                .then(() => {
                    showSuccessToast("Violations were acknowledged", "Acknowledge violations");
                    history.go(0);
                })
                .finally(() => finishLocalProcessingTask(processingTaskId));
        } else {
            showWarningToast("Select violations to acknowledge", "Acknowledge violations");
        }
    }

    return (
        <>
            <div className="card-header">
                <h2 className="card-title">MSB VIOLATIONS</h2>
                <div className="card-tools">
                    <div>
                        <div onClick={() => onAcknowledgeClick()}
                           className="oct_card-btn btn oct_btn-secondary">Acknowledge</div>
                        <div onClick={() => notImplemented()} className="oct_card-btn btn oct_btn-secondary">Export
                            Data</div>
                    </div>
                </div>
            </div>
            <div className="ml-4 mb-4">
                <ValidationResultTableSearchSection valid={false}/>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    debug("ValidateTableHeader mapStateToProps", state);
    return state;
}

export default connect(mapStateToProps)(ViolationsTableHeader);
